import FinancePaymentCalculator from "./FinancePaymentCalculator";
import LeasePaymentCalculator from "./LeasePaymentCalculator";
/**
 * Factory for creating payment calculators
 */

export class PaymentCalculatorFactory {
  static createCalculator(type, options) {
    switch (type) {
      case 'finance':
        return new FinancePaymentCalculator(options);

      case 'lease':
        return new LeasePaymentCalculator(options);
    }
  }

}
//# sourceMappingURL=PaymentCalculatorFactory.js.map